import useLocale from '../useLocale'

const getNewDesignPages = (locale: string) => [
  '/staking',
  '/buy-crypto',
  `/${locale}/staking`,
  `/${locale}/buy-crypto`,
  '/copytrading',
  `/${locale}/copytrading`,
  '/copytrading-competition',
  `/${locale}/copytrading-competition`,
  `/empty-header-page`,
  `/${locale}/empty-header-page`,
]

export const usePageType = () => {
  const { locale, pathname } = useLocale()
  const newDesignPages = getNewDesignPages(locale)
  const isNewDesignPage = newDesignPages.includes(pathname.replace('/page', ''))

  return isNewDesignPage ? 'secondary' : 'primary'
}
